import { ConsentResolutionSource } from '../../datagrail/datagrail';

let ga4Loaded = false;
let analyticsConsentGranted = false;
let consentResolvedVia: ConsentResolutionSource | undefined;
let consentResolutionWaitMs: number | undefined;

export const setGa4Loaded = () => {
  ga4Loaded = true;
};

export const isGa4Loaded = () => ga4Loaded;

export const setAnalyticsConsentGranted = (granted: boolean) => {
  analyticsConsentGranted = granted;
};

export const isAnalyticsConsentGranted = () => analyticsConsentGranted;

export const setConsentResolution = (resolvedVia: ConsentResolutionSource, waitMs: number) => {
  consentResolvedVia = resolvedVia;
  consentResolutionWaitMs = waitMs;
};

export const getConsentResolvedVia = () => consentResolvedVia;

export const getConsentResolutionWaitMs = () => consentResolutionWaitMs;
